<template>
    <v-form v-model="verifyCodeValid">
      <v-layout column pa-4>
        <p class="font-weight-light font-italic">
          We have sent a 6-digit code to {{to}} to verify you can receive notifications on it. Please enter this code below
        </p>
        <v-text-field type="number"
                      v-model="verifyCode"
                      ref="verifyCodeEl"
                      filled
                      label="Verification code"
                      required
                      clearable
                      counter="6"
                      hint="012345"
                      autofocus
                      :rules="verifyCodeRules"
                      :error="verifyCodeShowError"
                      @paste="interceptPaste"></v-text-field>
        <p class="font-weight-light caption">
          You should receive your code within a couple of minutes. If you do not receive a code <a class="font-weight-regular" style="text-decoration:underline" @click="resend">click here</a> and we'll send you a new one
        </p>
        <v-layout>
          <v-btn text color="error" @click="$emit('done')">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn type="submit"
                  @click.prevent="verifyAddress"
                  :disabled="!verifyCodeValid"
                  color="primary"
                  :loading="loadingState">Verify</v-btn>
        </v-layout>
      </v-layout>
    </v-form>         
</template>

<script>
  import axios from '../plugins/axios';

  export default {
    props: [
      'to',
      'sends'
    ],
    data: () => ({
      verifyCode: '',
      verifyCodeValid: false,
      verifyCodeRules: [
        v => /^\d*$/.test(v) || "The code can only contain numbers",
        v => !!v || "Please enter a 6 number code",
        v => v.length == 6 || "The code must be 6 digits long"
      ],
      verifyCodeShowError: false,
      loadingState_: false
    }),
    computed: {
      user() {
        return this.$store.state.user;
      },
      passengerId() {
        return this.$store.state.passengerId;
      },
      loadingState: {
        get() { return this.loadingState_; },
        set(v) {
          this.loadingState_ = v;
          this.$emit('loading', v);
        }
      }
     
    },
    methods: {     
      resend() {
        this.loadingState = true;
        axios.post('api/VerifyAddress/' + this.user.cnxUserId, this.sends).then((res) => {
          this.$emit('error', '');
        }).catch((err) => {
          var errorMsg = '';
          if (err.response && err.response.status == 401)
            errorMsg = 'You dont seem to be logged in - please refresh the page and log in again'
          else {
            errorMsg = 'Something went wrong. Please try refreshing the page and try again';
            console.log(err);
          }
          this.$emit('error', errorMsg);
        }).finally(() => {
          this.loadingState = false;
        });
      },
      interceptPaste(e) {
        this.pasteVerifyCode((e.clipboardData || window.clipboardData).getData('text'));
        e.preventDefault();
        return false;
      },
      pasteVerifyCode(string) {
        var r = /\b\d{6}\b/.exec(string)
        if (r)
          this.verifyCode = r[0];
        else {
          this.$refs.verifyCodeEl.errorBucket.splice(0, 0, "Please paste a valid code");
          this.verifyCodeShowError = true;
          this.verifyCode = ''
        }
      },
      verifyAddress() {
        this.loadingState = true;
        axios.post('api/VerifyAddress/' + this.user.cnxUserId + '/verify', Object.assign({}, this.sends, { OneTimePassword: this.verifyCode })).then((res) => {         
          return this.$store.dispatch("getOnlyContactAddresses").then(this.$emit('done'))
        }).catch((err) => {
          var errorMsg = '';
          if (err.response && err.response.status == 401)
            errorMsg = 'That code didnt match. Please enter the code you see in the SMS message we sent you';        
          else {
            errorMsg = 'Something went wrong. Please try refreshing the page and try again';
            console.log(err);
          }
          this.$emit('error', errorMsg);
        }).finally(() => {
          this.loadingState = false;
        });
      }
    }
  };
</script>
